import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20anime%20style%20cherry%20blossom%20landscape%20with%20soft%20pink%20petals%20falling%2C%20warm%20golden%20sunset%20light%2C%20dreamy%20atmosphere%2C%20distant%20mountains%2C%20artistic%20illustration%20style%2C%20ethereal%20and%20romantic%2C%20clean%20composition&width=1920&height=900&seq=hero-bg-sakura-01&orientation=landscape"
        alt="樱花漫画 - 韩漫日漫国漫免费在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="樱花漫画 - 韩漫日漫国漫免费在线阅读平台"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 text-center">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center">
            <i className="ri-flower-line text-4xl md:text-5xl text-primary-400"></i>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white">
            樱花漫画
          </h1>
        </div>

        <p className="text-white/90 text-base md:text-lg max-w-2xl mb-3 leading-relaxed">
          韩漫 · 日漫 · 国漫 — 漫画大全免费全集下拉式阅读
        </p>
        <p className="text-white/70 text-sm md:text-base max-w-xl mb-8 leading-relaxed">
          每日更新热门漫画，好看的漫画在线推荐，追更连载收藏一站搞定
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-book-open-line mr-2"></i>
            开始阅读
          </Link>
          <Link
            to="/category/korean"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white font-medium rounded-full border border-white/30 hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-fire-line mr-2"></i>
            热门韩漫
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10 text-white/60 text-xs">
          <div className="flex items-center gap-1.5">
            <i className="ri-bookmark-line"></i>
            <span>24部精选漫画</span>
          </div>
          <div className="w-px h-4 bg-white/25"></div>
          <div className="flex items-center gap-1.5">
            <i className="ri-eye-line"></i>
            <span>5000万+ 累计阅读</span>
          </div>
          <div className="w-px h-4 bg-white/25"></div>
          <div className="flex items-center gap-1.5">
            <i className="ri-user-heart-line"></i>
            <span>100万+ 漫画爱好者</span>
          </div>
        </div>
      </div>
    </section>
  );
}